import Select from 'react-select';
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 0, label: "Em digitação" },
    { value: 1, label: "Pendente de homologação" },
    { value: 2, label: "Revisar cadastro" },
    { value: 3, label: "Homologado" },
    { value: 4, label: "Cancelado" }
];

const SituacaoEquipamento = ({ field, placeholder, name, id, disabled=false }) => {
    return (
        <Select 
            options={options} 
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
        />
    )
}

export { SituacaoEquipamento, options as OpcoesSituacaoEquipamento }